import * as angular from 'angular';
import * as _ from 'lodash';
import EpxUnitResource from '../models/epx-unit-resource';
import ResourceService from './resource.service';
import SiteResource from '../models/site-resource';

export default class EpxUnitService extends ResourceService<EpxUnitResource> {
  constructor(private BackendService: any) {
    super(BackendService, EpxUnitResource);
  }

  build = () =>
    new EpxUnitResource({
      group: new SiteResource()
    });
}

angular.module('ciApp.services').service('EpxUnitService', ['BackendService', EpxUnitService]);



// WEBPACK FOOTER //
// ./common/services/epx-unit.service.ts